import { css } from "styled-components";

export const colors = {
  brand: "#F76367",
  white: "#ffffff",
  gray: "#ddd",
  green: "#19a974",
  red: "#e7040f",
  lightRed: "#FF725C",
  darkGreen: "#137752",
  black: "#000",
  transparent: "transparent"
};

const sizes = {
  giant: "2000px",
  desktop: "990px",
  tablet: "768px",
  phone: "376px"
};

export const media = Object.keys(sizes).reduce((accumulator, label) => {
  const size = sizes[label];
  return {
    ...accumulator,
    [label]: (...args) => css`
      @media (max-width: ${size}) {
        ${css(...args)};
      }
    `
  };
}, {});



// WEBPACK FOOTER //
// ./src/core/stylesheet/index.js